export default __webpack_public_path__ + "static/media/sound.4c424c00.mp3";